import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/cashbook', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOne(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/cashbook/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    add(ctx, cashbookData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/cashbook', cashbookData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    edit(ctx, cashbookData) {
      return new Promise((resolve, reject) => {
        const url = `/cashbook/${cashbookData.id}`
        axios
          .put(url, cashbookData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    del(ctx, id) {
      return new Promise((resolve, reject) => {
        const url = `/cashbook/${id}`
        axios
          .delete(url)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
